import * as React from "react";
import { FlexClickTracker } from "components/utility/analytics/FlexClickTracker/FlexClickTracker";
import { UitkPrimaryButton, UitkButtonSize } from "uitk-react-button";

const ButtonTracked = FlexClickTracker(UitkPrimaryButton);

export interface SubmitButtonProps {
  moduleName: string;
  submitButtonText: string;
  rfrr: string;
}

export const SubmitButton = React.memo<SubmitButtonProps>(({ moduleName, submitButtonText, rfrr }) => (
  <ButtonTracked
    tag="button"
    type="submit"
    rfrr={rfrr}
    linkName="Search button click event in the wizard"
    moduleName={moduleName}
    className="wizard-submit-btn"
    text={submitButtonText}
    size={UitkButtonSize.LARGE}
    isFullWidth={true}
    data-testid="wizard-submit-button"
  />
));

SubmitButton.displayName = "WizardHotelPWASubmitButton";
